<template>
  <div class="situation" ref="situation">
    <div class="type-blue-wrap" v-if="styleType == 'typeBlue'">
      <div class="left">
        <div class="pm25">PM2.5</div>
        <div class="real-value">
          <div class="factory">
            <div class="name" :title="name">{{ name }}</div>
            <div class="number">{{ pm25 }}</div>
          </div>
          <div
            class="province"
            v-show="
              customerId !== 17 &&
              customerId !== 67 &&
              customerId !== 117 &&
              customerId !== 127
            "
          >
            <div class="name">
              {{ customerId == 92 ? "国控" : "省控" }}
            </div>
            <div class="number">{{ skpm25 }}</div>
          </div>
        </div>
        <div class="history-search" @click="checkLine('pm2.5')">查看历史</div>
      </div>
      <div class="center-value">
        <div class="number">{{ AQIVal }}</div>
        <div
          class="txt-degree"
          :class="{
            'txt-ran-yellow': ranYellow,
            'txt-ran-orange': ranOrange,
            'txt-ran-red': ranRed,
            'txt-ran-purple': ranPurple,
            'txt-ran-BrownRed': ranBrownRed,
          }"
        ></div>
      </div>
      <div class="right">
        <div class="pm25">PM10</div>
        <div class="real-value">
          <div class="factory">
            <div class="name" :title="name">{{ name }}</div>
            <div class="number">{{ pm10 }}</div>
          </div>
          <div
            class="province"
            v-show="
              customerId !== 17 &&
              customerId !== 67 &&
              customerId !== 117 &&
              customerId !== 127
            "
          >
            <div class="name">
              {{ customerId == 92 ? "国控" : "省控" }}
            </div>
            <div class="number">{{ skpm10 }}</div>
          </div>
        </div>
        <div class="history-search" @click="checkLine('pm10')">查看历史</div>
      </div>
    </div>
    <div v-else class="AQIbg" :style="{ marginTop: getAQIStyle }">
      <div class="left" @click="checkLine('pm2.5')">
        <div class="leftFactory">
          <div
            class="ll"
            :style="
              customerId == 76 ||
              customerId == 69 ||
              customerId == 68 ||
              customerId == 105
                ? 'width:43%;'
                : 'width:32%'
            "
          >
            <div class="leftName" v-if="customerId != 81">
              {{ customerId == 92 ? "萍安钢铁" : name }}
            </div>
            <div class="pm25" v-if="customerId != 81">PM2.5</div>
            <div class="pm25 wf-st" v-if="customerId == 81">PM2.5</div>
          </div>
          <div style="margin-left: 25px" class="leftPM25 number">
            {{ pm25 }}
          </div>
        </div>
        <div
          class="leftProvince"
          v-show="customerId !== 17 && customerId !== 23"
        >
          <div
            class="ll"
            :class="{ SGStyle: customerId == 39 }"
            :style="
              customerId == 76 ||
              customerId == 69 ||
              customerId == 58 ||
              customerId == 105
                ? 'width:43%;'
                : 'width:32%'
            "
          >
            <div v-if="customerId == 58">
              <div class="leftName width-limit" v-if="skname.length <= 6">
                {{ skname }}
              </div>
              <marquee scrollamount="4" v-if="skname.length > 6">{{
                skname
              }}</marquee>
            </div>
            <div v-else>
              <div class="leftName width-limit" v-if="customerId != 81">
                {{ skname }}
              </div>
            </div>
            <div class="pm25" v-if="customerId != 81">PM2.5</div>
            <div class="pm25 wf-st" v-if="customerId == 81">风速</div>
          </div>
          <div style="margin-left: 25px" class="leftPM25 number">
            {{ skpm25 }}
          </div>
        </div>
      </div>
      <div
        class="main"
        :style="{ marginTop: getMainStyle }"
        :class="{ pointer: customerId == 38, baoSteel: isBaoSteel }"
        @click="checkLine('aqi')"
      >
        <div class="aqi absolute_center">AQI</div>
        <div class="number bignumber absolute_center">
          {{ AQIVal }}
          <div
            class="txt-ran absolute_center"
            :class="{
              'txt-ran-yellow': ranYellow,
              'txt-ran-orange': ranOrange,
              'txt-ran-red': ranRed,
              'txt-ran-purple': ranPurple,
              'txt-ran-BrownRed': ranBrownRed,
            }"
          ></div>
        </div>
      </div>
      <div class="right" @click="checkLine('pm10')">
        <div class="rightFactory">
          <div class="rightPM10 number">{{ pm10 }}</div>
          <div
            class="rl"
            :style="
              customerId == 76 || customerId == 69 || customerId == 58
                ? 'width:43%;'
                : customerId == 105
                ? 'width:54%;'
                : 'width:32%'
            "
          >
            <div v-if="customerId != 81" class="rightName">
              {{ customerId == 92 ? "萍安钢铁" : name }}
            </div>
            <div class="pm10" v-if="customerId != 81">PM10</div>
            <div class="pm10 wf-st" v-if="customerId == 81">PM10</div>
          </div>
        </div>
        <div
          class="rightProvince"
          v-show="customerId !== 17 && customerId !== 23"
        >
          <div class="rightPM10 number">{{ skpm10 }}</div>
          <div
            class="rl"
            :class="{ SGStyle: customerId == 39 }"
            :style="
              customerId == 76 || customerId == 69 || customerId == 58
                ? 'width:43%;'
                : customerId == 105
                ? 'width:54%;'
                : 'width:32%'
            "
          >
            <div v-if="customerId == 58">
              <div class="leftName width-limit" v-if="skname.length <= 6">
                {{ skname }}
              </div>
              <marquee scrollamount="4" v-if="skname.length > 6">{{
                skname
              }}</marquee>
            </div>
            <div v-else>
              <div class="leftName width-limit" v-if="customerId != 81">
                {{ skname }}
              </div>
            </div>
            <div v-if="customerId != 81" class="pm10">PM10</div>
            <div class="pm10 wf-st" v-if="customerId == 81">气温</div>
          </div>
        </div>
      </div>
      <!-- <div v-show="customerId == 22" class="referencePoint">
        参考点:&nbsp;&nbsp;临汾{{ allData.siteName }}
      </div>-->
      <div v-show="customerId == 23" class="referencePoint">
        天津市空气质量指数
      </div>
    </div>
  </div>
</template>

<script>
import historyDialogPm25 from "./components/historyDialogPm25/index.vue";
import historyDialogPm10 from "./components/historyDialogPm10";
import historyDialogPm10Pm25 from "./components/historyDialogPm10Pm25";
import aqiDialog from "./components/aqiDialog";
import { mapState, mapGetters } from "vuex";
import { onDeactivated } from "vue";
import { getCurrentInstance, computed } from "vue";
import mybus from "@/utils/eventbus";

export default {
  components: {
    historyDialogPm25,
    historyDialogPm10,
    historyDialogPm10Pm25,
    aqiDialog,
  },
  setup() {
    const { proxy } = getCurrentInstance(); // 获取当前组件实例
    const ctx = proxy;

    return {
      ctx,
    };
  },
  props: ["matrix", "x", "y"],
  data() {
    return {
      pageInfo: "situation_new.vue",
      computedName: "实际环境组件",
      customerId: this.$store.state.customerId,
      pm10: 0,
      pm25: 0,
      skpm10: 0,
      skpm25: 0,
      name: " ",
      winddirection: "",
      Provincial: 0,
      Factory: 0,
      noData: false,
      AQIVal: 0,
      polluRan: "",
      mainPollutants: "", //PM10/PM25
      ranYellow: false,
      ranOrange: false,
      ranRed: false,
      ranPurple: false,
      ranBrownRed: false,
      setTime1: null,
      styleType: "",
      setTime38: null,
      setTime_showFactory: null,
      skname:
        bmeConfig.customerSign == 92
          ? "国控"
          : customerId == 46
          ? "省均"
          : "省控",
      allData: {},
      changeNum: 1,
      isBaoSteel: bmeConfig.isBaoSteel,
    };
  },
  computed: {
    ...mapGetters({
      dialogCompontent: "getDialogCompontent",
    }),
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
    getAQIStyle() {
      if (this.customerId === 22) {
        return "30px";
      } else {
        return "40px";
      }
    },
    getMainStyle() {
      if (this.customerId === 22) {
        return "10px";
      } else {
        return "20px";
      }
    },
  },
  watch: {
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    let that = this;
    let w = $(that.$refs.situation).outerWidth();
    let h = $(that.$refs.situation).outerHeight();
    that.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: that.matrix,
      x: that.x,
      y: that.y,
    });
    this.getPmData();
    mybus.$on("showRealTimeValue", (val) => {
      if (val !== null) {
        if (
          this.$store.state.dialogStatus == true &&
          this.$store.state.dialogComponent_class == "realtimeENV"
        ) {
          this.$popup.close(this, "realtimeENV");
        } else {
          this.checkLine(val);
        }
      } else {
        this.$popup.close(this, "realtimeENV");
      }
    });
  },
  unmounted() {
    if (this.setTime1) {
      clearTimeout(this.setTime1);
      this.setTime1 = null;
    }
    if (this.setTime38) {
      clearTimeout(this.setTime38);
      this.setTime38 = null;
    }
    if (this.setTime_showFactory) {
      clearTimeout(this.setTime_showFactory);
      this.setTime_showFactory = null;
    }
  },
  methods: {
    formatInt(num, prec = 1, ceil = false) {
      const len = String(num).length;
      if (len <= prec) {
        return 0;
      }
      const mult = Math.pow(10, prec);
      return ceil
        ? Math.ceil(num / mult) * mult
        : Math.floor(num / mult) * mult;
    },
    is38Factory() {
      if (this.setTime38) {
        clearTimeout(this.setTime38);
        this.setTime38 = null;
      }
      if (this.customerId == 3800) {
        if (this.changeNum == 0) {
          this.changeNum = 1;
          this.skname = "张家港市";
          this.skpm10 = this.isNumber(this.allData.zjg.pm10);
          this.skpm25 = this.isNumber(this.allData.zjg.pm25);
        } else {
          this.changeNum = 0;
          this.skname =
            this.customerId == 92
              ? "国控"
              : customerId == 46
              ? "省均"
              : "省控";
          this.skpm10 = this.isNumber(this.allData.provincialPm10);
          this.skpm25 = this.isNumber(this.allData.provincialPm25);
        }
        this.setTime38 = setTimeout(() => {
          this.is38Factory();
        }, 10 * 1000);
      }
    },
    isShowFactory() {
      if (this.setTime_showFactory) {
        clearTimeout(this.setTime_showFactory);
        this.setTime_showFactory = null;
      }
      if (
        this.changeNum == 0 &&
        this.customerId != 92 &&
        this.customerId != 46 &&
        this.customerId != 50 &&
        this.customerId != 38
      ) {
        this.changeNum = 1;
        this.skname = this.allData.siteName;
      } else {
        this.changeNum = 0;
        this.skname =
          this.customerId == 92
            ? "国控"
            : customerId == 46
            ? "省均"
            : "省控";
      }
      this.skpm10 = this.isNumber(this.allData.provincialPm10);
      this.skpm25 = this.isNumber(this.allData.provincialPm25);
      this.setTime_showFactory = setTimeout(() => {
        this.isShowFactory();
      }, 10 * 1000);
    },
    async getPmData() {
      if (this.setTime1) {
        clearTimeout(this.setTime1);
        this.setTime1 = null;
      }
      let findRealTimeValue =
        CONFIG.requestName + this.$apiOpt.findRealTimeValue;
      let data = await this.$apiUtils.get(findRealTimeValue, {
        customerId: this.customerId,
      });
      if (data) {
        this.allData = data;
        this.pm10 = this.isNumber(data?.factoryPm10);
        this.pm25 = this.isNumber(data?.factoryPm25);
        this.skpm10 = this.isNumber(data?.provincialPm10);
        this.skpm25 = this.isNumber(data?.provincialPm25);
        this.name = data?.customerName;
        if (this.customerId == 6) {
          this.name = this.name.slice(0, 4);
        }
        this.AQIVal = data?.value || 0;
        this.ranYellow =
          this.ranOrange =
          this.ranRed =
          this.ranPurple =
          this.ranBrownRed =
            false;
        // if (this.customerId == 38) {
        //   this.is38Factory();
        // } else {
        this.isShowFactory();
        // }
        // if (this.customerId == 66 || this.customerId == 39 || this.customerId == 75) {
        //   this.skname = data?.siteName
        // }
        if (data.aqidetail == "优") {
        } else if (data.aqidetail == "良") {
          this.ranYellow = true;
        } else if (data.aqidetail == "轻度") {
          this.ranOrange = true;
        } else if (data.aqidetail == "中度") {
          this.ranRed = true;
        } else if (data.aqidetail == "重度") {
          this.ranPurple = true;
        } else if (data.aqidetail == "严重") {
          this.ranBrownRed = true;
        }
      }
      if (this.customerId == 42) {
        this.setTime1 = setTimeout(() => {
          this.getPmData();
        }, 60 * 1000 * 1.5);
      } else {
        this.setTime1 = setTimeout(() => {
          this.getPmData();
        }, 60 * 1000 * 30);
      }
    },
    isNumber(num) {
      if (!isNaN(parseInt(num))) {
        if (num !== 0) {
          return Math.round(num);
        }
      } else {
        return 0;
      }
    },
    checkLine(type) {
      if (this.customerId == "40") {
        if (type == "pm2.5" || type == "pm10") {
          this.$store.state.currentRealtimeENVType = type;
          let dom = document.getElementsByClassName("realtimeENV");
          if (dom.length == 0) {
            this.$store.commit("dialogStatus", true);
            this.$popup.open(
              historyDialogPm10Pm25,
              this.dialogCompontent,
              this,
              null,
              null,
              "realtimeENV"
            );
          }
        }
      } else {
        if (type == "pm2.5") {
          this.$store.commit("dialogStatus", true);
          this.$popup.open(
            historyDialogPm25,
            this.dialogCompontent,
            this,
            null,
            null,
            "realtimeENV"
          );

          this.$store.state.dialogComponent_class = "realtimeENV";
        } else if (type == "pm10") {
          this.$store.commit("dialogStatus", true);
          this.$store.state.dialogComponent_class = "realtimeENV";
          this.$popup.open(
            historyDialogPm10,
            this.dialogCompontent,
            this,
            null,
            null,
            "realtimeENV"
          );

          this.$store.state.dialogComponent_class = "realtimeENV";
        } else if (type == "aqi" && this.customerId == 38) {
          this.$store.commit("dialogStatus", true);
          this.$store.state.dialogComponent_class = "realtimeENV";
          this.$popup.open(
            aqiDialog,
            this.dialogCompontent,
            this,
            null,
            null,
            "realtimeENV"
          );

          this.$store.state.dialogComponent_class = "realtimeENV";
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.situation {
  width: 600px;
  height: 250px;

  .AQIbg {
    @include bg-box(560px, 167px, "AQIbg.png");
    margin-top: 40px;
    display: flex;
    justify-content: space-between;

    .left {
      width: 50%;
      height: 100%;
      cursor: pointer;

      .leftFactory {
        height: 50%;
        padding: 19px 24px;
        display: flex;
      }

      .leftProvince {
        height: 50%;
        padding: 21px 24px 17px 24px;
        display: flex;
      }

      .leftName {
        white-space: nowrap;
        font-size: 16px;
        font-weight: 400;
        color: #e0e0e0;
        line-height: 16px;
        height: 50%;
        // overflow: hidden;
      }

      .width-limit {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .pm25 {
        width: 48px;
        font-size: 16px;
        font-weight: 400;
        color: #70abff;
        line-height: 16px;
        height: 50%;
      }

      .ll {
        width: 32%;
      }

      .SGStyle {
        width: 58% !important;
      }

      .leftPM25 {
      }
    }

    .right {
      width: 50%;
      height: 100%;
      cursor: pointer;

      .rightFactory {
        height: 50%;
        padding: 19px 24px;
        display: flex;
        justify-content: flex-end;
      }

      .rightProvince {
        height: 50%;
        padding: 21px 24px 17px 24px;
        display: flex;
        justify-content: flex-end;
      }

      .rightName {
        white-space: nowrap;
        font-size: 16px;
        font-weight: 400;
        color: #e0e0e0;
        line-height: 16px;
        height: 50%;
        // float: right;
        // overflow: hidden;
      }

      .width-limit {
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .pm10 {
        line-height: 16px;
        height: 50%;
        font-size: 16px;
        font-weight: 400;
        color: #ffe670;
      }

      .rl {
        width: 32%;
        text-align: end;
      }

      .SGStyle {
        width: 58% !important;
      }

      .rightPM10 {
        width: 50%;
        text-align: end;
      }
    }

    .main {
      width: 116px;
      height: 116px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      background: linear-gradient(
        225deg,
        rgba(106, 255, 211, 0.32) 0%,
        #2c5ed8 100%
      );
      box-shadow: 0px 0px 4px 0px rgba(0, 255, 250, 0.4);
      border-radius: 50%;
      margin-top: 20px;

      &.baoSteel {
        background: linear-gradient(
          180deg,
          #05fffa 0%,
          rgba(5, 251, 246, 0) 100%
        );
        box-shadow: 0px 0px 4px 0px rgba(0, 255, 250, 0.4);
      }

      .aqi {
        top: 17%;
      }

      .bignumber {
        text-align: center;
        top: 51%;
      }

      .txt-ran {
        top: 111%;
        width: 20px;
        height: 20px;
        background-image: url("./img/img_label 1.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
      }
    }

    .pointer {
      cursor: pointer;
      z-index: 2;
    }
  }

  .type-blue-wrap {
    @include bg-box(100%, 175px, "AQIbg_blue.png");
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 22px;

    .left,
    .right {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      flex: 1;

      .pm25 {
        font-size: 23px;
        font-weight: 400;
        color: #51eeff;
        line-height: 32px;
      }

      .real-value {
        display: flex;
        margin-top: 8px;

        .factory,
        .province {
          text-align: center;
          font-size: 18px;
          font-weight: 400;
          color: #ffffff;
          line-height: 25px;
          white-space: nowrap;
          display: flex;
          align-items: center;
          flex-direction: column;
          margin-right: 10px;

          .number {
            color: #ffffff;
            font-size: 24px;
            line-height: 24px;
            height: 28px;
            width: auto;
          }

          .name {
            max-width: 110px;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        .province {
          margin-right: 0px;
        }
      }

      .history-search {
        width: 118px;
        height: 30px;
        background: #1d5571;
        border-radius: 1px;
        font-size: 17px;
        color: #ffffff;
        line-height: 30px;
        text-align: center;
        margin-top: 8px;
        cursor: pointer;
      }
    }

    .right {
      flex: 1;
    }

    .center-value {
      flex: 1;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;

      .number {
        font-size: 54px;
        font-weight: 400;
        color: #ffffff;
        line-height: 54px;
        height: 54px;
        width: 100%;
        text-align: center;
        margin-top: 30px;
      }

      .txt-degree {
        background-image: url("./img/img_label_blue 1.png");
        background-repeat: no-repeat;
        background-position: center;
        background-size: 100% 100%;
        height: 22px;
        width: 50px;
        margin-top: 5px;
      }

      .txt-ran-yellow {
        background-image: url("./img/img_label_blue 2.png") !important;
      }

      .txt-ran-orange {
        background-image: url("./img/img_label_blue 3.png") !important;
      }

      .txt-ran-red {
        background-image: url("./img/img_label_blue 4.png") !important;
      }

      .txt-ran-purple {
        background-image: url("./img/img_label_blue 5.png") !important;
      }

      .txt-ran-BrownRed {
        background-image: url("./img/img_label_blue 6.png") !important;
      }
    }
  }
}

.referencePoint {
  position: absolute;
  bottom: 3px;
  left: 50%;
  transform: translate(-50%);
  font-size: 18px;
  color: #a6caff;
  text-shadow: 2px 2px 2px #000;
}
</style>
<style scoped>
.number {
  width: 42px;
  height: 48px;
  font-size: 48px;
  font-weight: 400;
  color: #65f5f2;
  line-height: 48px;
  text-shadow: 0px 2px 6px #0091ff;
}

.number.bignumber {
  width: 113px;
  height: 68px;
  font-size: 58px;
  font-weight: 400;
  color: #ffffff;
  line-height: 69px;
  text-shadow: 0px 0px 4px rgba(0, 255, 250, 0.4);
}

.txt-ran-yellow {
  background-image: url("./img/img_label 2.png") !important;
}

.txt-ran-orange {
  background-image: url("./img/img_label 3.png") !important;
  width: 40px !important;
}

.txt-ran-red {
  background-image: url("./img/img_label 4.png") !important;
  width: 40px !important;
}

.txt-ran-purple {
  background-image: url("./img/img_label 5.png") !important;
  width: 40px !important;
}

.txt-ran-BrownRed {
  background-image: url("./img/img_label 6.png") !important;
  width: 40px !important;
}
.wf-st {
  font-size: 20px !important;
  line-height: 45px !important;
}
</style>
